module.exports = __webpack_public_path__ + "static/media/coursera.6be1b7d1.png";